import React, { useContext, useEffect, useState } from 'react'
import OtpInput from 'react-otp-input';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL_API } from '../../References/URLs';
import ActiveStoreContext from '../../store/ActiveStoreContext';
import AuthContext from '../../store/auth-context';
import styles from '../Users/AddNewClient.module.css'
import { Link } from 'react-router-dom'
import { FiPhone, FiUser, FiMail, FiMapPin, FiCalendar, FiUserPlus, FiX, FiUsers, FiLoader, FiInfo } from 'react-icons/fi';
import { getAge } from '../../Helper/calculations';

const AddNewClient = props => {
    const authCtx = useContext(AuthContext);
    const { isOpen, closeModal, assignClient } = props

    const [isReadyToSubmit, setIsReadyToSubmit] = useState(false);
    const [creationStatus, setCreationStatus] = useState('NOT_UPDATING'); // UPDATING
    const [isAlreadyRegistered, setIsAlreadyRegistered] = useState(false)
    const [clientToAssign, setClientToAssign] = useState(null)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const [dob, setDob] = useState('')
    window.onclick = function (event) {
        if (event.target.id === "addNewClientForm") {
            closeModal();
        }

        if (event.target.id === "filtersPanelWrapperMUG") {
            document.getElementById("filtersPanelWrapperMUG").style.animation = "slideRightToLeft .1s forwards";
        }

    }

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            document.getElementById("filtersPanelWrapperMUG").style.animation = "slideRightToLeft .1s forwards";
            closeModal()
        }
    });

    const [phoneNumber, setPhoneNumber] = useState({
        otp: props.phone
    });
    const [fullName, setFullName] = useState('');
    const [middleName, setMiddleName] = useState('')
    const [gender, setGender] = useState('')
    const [address, setAddress] = useState('')
    const [dayAnniversary, setDayAnniversary] = useState('')
    const [monthAnniversary, setMonthAnniversary] = useState('')
    const [email, setEmail] = useState('')
    const [title, setTitle] = useState('')

    const phoneNumberHandler = (otp) => {
        setPhoneNumber({ otp });
    }

    const isReadyHandler = () => {
        if (phoneNumber?.otp?.length === 10) {
            if (fullName?.trim()?.length > 1) {
                if (gender !== '') {
                    setIsReadyToSubmit(true)
                } else {
                    setIsReadyToSubmit(false)
                }
            } else {
                setIsReadyToSubmit(false)
            }
        } else {
            setIsReadyToSubmit(false)
        }
    }

    useEffect(() => {
        isReadyHandler()
    }, [phoneNumber, fullName, gender])

    useEffect(() => {
        setPhoneNumber({ otp: props.phone })
    }, [props.phone])

    useEffect(() => {
        if (isOpen === false) {
            setPhoneNumber({ otp: '' })
            setIsAlreadyRegistered(false)
            setFullName('')
            setMiddleName('')
            setGender('')
            setAddress('')
            setEmail('')
            setTitle('')
        }
    }, [isOpen])


    const assignClientHandler = (k) => {
        assignClient(k)
        closeModal()
    }

    const addNewClientHandler = async () => {
        setCreationStatus('UPDATING')

        const clientFullName = fullName.trim()

        console.log(phoneNumber.otp, clientFullName, middleName, gender, address, dayAnniversary, monthAnniversary)

        const addNewClientResponse = await fetch(BASE_URL_API + "addNewClient",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    mobile: phoneNumber.otp,
                    firstName: clientFullName,
                    middleName: middleName,
                    lastName: '',
                    gender: gender,
                    address: address,
                    dob: dob,
                    salutation: title,
                    email: email
                })
            });

        if (!addNewClientResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const addNewClientRespo = await addNewClientResponse.json();
            if (addNewClientRespo.status === 'success') {
                if (assignClient !== undefined) {
                    assignClient(addNewClientRespo.response)
                    closeModal()
                }
                toast.success("Client successfully onboarded!")
            } else {
                if (addNewClientRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else if (addNewClientRespo.message === 'user already registered') {
                    toast(`Client is already registered!`)
                    if (assignClient !== undefined) {
                        setIsAlreadyRegistered(true)
                        setClientToAssign(addNewClientRespo?.response)
                        // assignClient(addNewClientRespo.response)
                        // closeModal()
                    }
                }
            }

            console.log(addNewClientRespo);
        }

        setCreationStatus('NOT_UPDATING')

    }


    const [ageYear, setAgeYear] = useState('')
    const [ageMonth, setAgeMonth] = useState('')

    const [years, setYears] = useState([]);

    useEffect(() => {
        const yearsArray = [];

        for (let year = 120; year >= 0; year--) {
            yearsArray.push(year);
        }

        setYears(yearsArray);
    }, []);

    const getPastDate = (year, month) => {
        // Get the current date
        const currentDate = new Date();

        // Create a new Date object for the given year and month, setting the day to 1
        let date = new Date(currentDate.getFullYear() - year, month - 1, 1);

        // If the generated date is in the future, adjust the year backward by 1 year
        if (date > currentDate) {
            date.setFullYear(date.getFullYear() - 1);
        }

        // Format the date as "yyyy-MM-dd"
        const formattedDate = date.toISOString().split('T')[0];

        setDob(formattedDate);
    };

    useEffect(() => {
        if (!ageYear) {
            setAgeMonth('')
            return
        }
        const currentMonth = new Date().getMonth() + 1
        setAgeMonth(currentMonth)
        getPastDate(ageYear, currentMonth)
    }, [ageYear])


    const minimumRequirementsCopy = isAlreadyRegistered
        ? 'Client already exists in your store records.'
        : 'Phone number, full name, and gender are required.';

    if (isOpen) {
        return (
            <div className={styles.mainWrapper}>
                <div
                    className={styles.filtersPanelWrapper}
                    id="addNewClientForm"
                    style={{ animation: `openAddNewClientPanel 0.2s forwards` }}
                >
                    <div className={styles.drawer}>
                        <div className={styles.drawerHeader}>
                            <div className={styles.headerGroup}>
                                <span className={styles.headerBadge}>
                                    <FiUserPlus size={12} />
                                    Quickly Add New Client
                                </span>
                                <p className={styles.headerSubtitle}>
                                    Capture essentials and continue without leaving your flow.
                                </p>
                            </div>
                            <button
                                type="button"
                                className={styles.closeButton}
                                onClick={closeModal}
                                aria-label="Close add client dialog"
                            >
                                <FiX size={16} />
                            </button>
                        </div>

                        <div className={styles.drawerContent}>
                            {creationStatus === 'NOT_UPDATING' ? (
                                isAlreadyRegistered ? (
                                    <div className={styles.registeredCard}>
                                        <div className={styles.registeredHeader}>
                                            <span className={styles.registeredBadge}>Existing Profile</span>
                                            <div className={styles.registeredName}>
                                                {clientToAssign?.client_name}
                                            </div>
                                        </div>
                                        <div className={styles.registeredMeta}>
                                            {clientToAssign?.client_address && (
                                                <span>
                                                    <FiMapPin size={12} /> {clientToAssign?.client_address}
                                                </span>
                                            )}
                                            <span className={styles.registeredPhone}>
                                                <FiPhone size={12} />
                                                <span>{clientToAssign?.countryCode}</span>
                                                <span>{clientToAssign?.mobile}</span>
                                            </span>
                                        </div>
                                        <div className={styles.familySummary}>
                                            <FiUsers size={12} />{' '}
                                            {Array.isArray(clientToAssign?.relatives && JSON.parse(clientToAssign?.relatives))
                                                ? JSON.parse(clientToAssign?.relatives)?.length
                                                : 0} family members linked
                                        </div>
                                        <div className={styles.relativesWrapper}>
                                            {(clientToAssign?.relatives && (() => {
                                                try {
                                                    const parsedRelatives = JSON.parse(clientToAssign.relatives);
                                                    return Array.isArray(parsedRelatives) ? parsedRelatives : [];
                                                } catch (error) {
                                                    console.error('Error parsing relatives:', error);
                                                    return [];
                                                }
                                            })())?.map((itemRelative, index) => (
                                                <div key={index} className={styles.eachRelative}>
                                                    <div className={styles.erUpper}>
                                                        <div className={styles.rFullName}>
                                                            {itemRelative?.salutation}{' '}
                                                            {`${itemRelative?.firstName} ${itemRelative?.middleName} ${itemRelative?.lastName}`.trim()}
                                                        </div>
                                                        <div className={styles.rAge}>
                                                            {getAge(itemRelative?.dateOfBirth)} years
                                                        </div>
                                                    </div>
                                                    <div className={styles.erLower}>
                                                        <div>{itemRelative?.gender}</div>
                                                        <div className={styles.rtfh}>{itemRelative?.relationToFamilyHead}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className={styles.alreadyRegisteredLink}>
                                            <Link to={`/user/${clientToAssign?.clientStoreRelationIdentifier}`}>
                                                Add a relative to this family
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.formGrid}>
                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiPhone size={14} /> Phone Number
                                            </label>
                                            <OtpInput
                                                value={phoneNumber.otp}
                                                focusInput={0}
                                                numInputs={10}
                                                shouldAutoFocus
                                                onChange={(otp) => phoneNumberHandler(otp)}
                                                isInputNum
                                                containerStyle={styles.phoneNumberContainer}
                                                inputStyle={styles.phoneInputBox}
                                                focusStyle={styles.otpFocus}
                                            />
                                            <p className={styles.fieldInfo}>We’ll send alerts to this number.</p>
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldSnug}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiUser size={14} /> Title
                                            </label>
                                            <select
                                                className={styles.selectControl}
                                                onChange={(e) => setTitle(e.target.value)}
                                                value={title}
                                            >
                                                <option value="">Title</option>
                                                <option value="Mr.">Mr.</option>
                                                <option value="Ms.">Ms.</option>
                                                <option value="Mrs.">Mrs.</option>
                                                <option value="Dr.">Dr.</option>
                                                <option value="Baby">Baby</option>
                                                <option value="Kumari">Kumari</option>
                                            </select>
                                        </div>

                                        <div className={styles.field}>
                                            <label className={styles.fieldLabel}>
                                                <FiUser size={14} /> Full Name
                                            </label>
                                            <input
                                                className={styles.inputControl}
                                                onChange={(e) => setFullName(e.target.value)}
                                                value={fullName}
                                                placeholder="e.g. Aishwarya Singh"
                                            />
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiMail size={14} /> Email
                                            </label>
                                            <input
                                                className={styles.inputControl}
                                                placeholder="Client email ID"
                                                onChange={(e) => setEmail(e.target.value)}
                                                value={email}
                                            />
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiUser size={14} /> Gender
                                            </label>
                                            <div className={styles.genderRow}>
                                                {['Male', 'Female', 'LGBTQ', 'Unknown'].map((option) => (
                                                    <button
                                                        key={option}
                                                        type="button"
                                                        onClick={() => setGender(option)}
                                                        className={gender === option ? `${styles.genderButton} ${styles.genderButtonActive}` : styles.genderButton}
                                                    >
                                                        {option}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiMapPin size={14} /> Address
                                            </label>
                                            <textarea
                                                className={styles.textAreaControl}
                                                rows={3}
                                                onChange={(e) => setAddress(e.target.value)}
                                                value={address}
                                                placeholder="House, street, locality"
                                            />
                                        </div>

                                        <div className={styles.ageFields}>
                                            <div className={styles.field}>
                                                <label className={styles.fieldLabel}>
                                                    <FiCalendar size={14} /> Age (Years)
                                                </label>
                                                <select
                                                    className={styles.selectControl}
                                                    onChange={(e) => setAgeYear(e.target.value)}
                                                    value={ageYear}
                                                >
                                                    <option value="">Select</option>
                                                    {years?.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className={styles.field}>
                                                <label className={styles.fieldLabel}>
                                                    <FiCalendar size={14} /> Date of Birth
                                                </label>
                                                <input
                                                    type="date"
                                                    className={styles.dateControl}
                                                    value={dob}
                                                    onChange={(e) => setDob(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div className={styles.loaderState}>
                                    <FiLoader size={26} className={styles.loaderIcon} />
                                    <span>Adding client — hold on a second.</span>
                                </div>
                            )}
                        </div>

                        <div className={styles.drawerFooter}>
                            <span className={styles.footerHint}>
                                <FiInfo size={12} /> {minimumRequirementsCopy}
                            </span>
                            <div className={styles.footerActions}>
                                <button type="button" className={styles.secondaryButton} onClick={closeModal}>
                                    Cancel
                                </button>
                                {isAlreadyRegistered ? (
                                    <button
                                        type="button"
                                        className={styles.primaryButton}
                                        onClick={() => assignClientHandler(clientToAssign)}
                                        disabled={creationStatus !== 'NOT_UPDATING'}
                                    >
                                        Assign Client
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className={styles.primaryButton}
                                        onClick={addNewClientHandler}
                                        disabled={!isReadyToSubmit || creationStatus !== 'NOT_UPDATING'}
                                    >
                                        Add Client
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return null
}

export default AddNewClient